import ProductDetailHero from "./productDetailHero";
import ProductInfoCard from "./ProductInfoCard";
import ProductDemoGallery from "./ProductDemoGallery";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getProductById } from "../../api/productApi";

interface ProductCategory {
  id: number;
  name: string;
}

interface ProductImage {
  id: number;
  image: string;
}

interface ProductDescription {
  id: number;
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

interface ProductDetailResponse {
  id: number;
  name: string;
  slug: string;
  category: ProductCategory;
  subCategory: ProductCategory;
  status: boolean;
  createdAt?: string;
  updatedAt?: string;
  productImages: ProductImage[];
  productDemoImages: ProductImage[];
  descriptions: ProductDescription[];
}

export default function ProductDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState<ProductDetailResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchProduct(Number(id));
    }
  }, [id]);

  const fetchProduct = async (productId: number) => {
    try {
      setLoading(true);

      const response = await getProductById(productId);

      setProduct(response.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen bg-[#ECECEC] pb-20">
      <ProductDetailHero />

      <div className="relative z-20 -mt-24 mx-auto max-w-5xl space-y-6 px-6">
        {loading && <ProductDetailSkeleton />}

        {!loading && !product && (
          <div className="rounded-[32px] bg-white p-10 text-center shadow-xl">
            <p className="text-lg font-semibold text-[#324A5A]">
              Produk tidak ditemukan
            </p>
            <p className="mt-1 text-sm text-slate-400">
              Produk yang kamu cari mungkin sudah tidak tersedia.
            </p>
            <button
              onClick={() => navigate("/Home")}
              className="mt-6 rounded-full bg-[#3DA4A8] px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-[#2F8C90]">
              Kembali ke Home
            </button>
          </div>
        )}

        {!loading && product && (
          <>
            <ProductInfoCard product={product} />
            <ProductDemoGallery images={product.productDemoImages} />
          </>
        )}
      </div>
    </section>
  );
}

function ProductDetailSkeleton() {
  return (
    <div className="animate-pulse rounded-[32px] bg-white p-6 shadow-xl lg:p-10">
      <div className="grid gap-10 lg:grid-cols-2 lg:gap-14">
        <div className="aspect-square rounded-3xl bg-slate-100" />
        <div className="space-y-4">
          <div className="h-6 w-32 rounded-full bg-slate-100" />
          <div className="h-10 w-3/4 rounded-lg bg-slate-100" />
          <div className="h-4 w-40 rounded bg-slate-100" />
          <div className="mt-8 h-12 w-full rounded-2xl bg-slate-100" />
        </div>
      </div>
    </div>
  );
}
